var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center warning--text pa-2 mb-2 fs-14px font-weight-medium"},[_vm._v(" GIAO ĐI ")]),(_vm.order.delivery_status == 2)?_c('DeliveryProcessingStep1',{attrs:{"order":_vm.order},on:{"confirmed":_vm.confirmed}}):_c('DeliveryProcessingStep2',{attrs:{"order":_vm.order},on:{"finished":_vm.finished}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }